export const scrollToTop = (id?: string) => {
    const ele = document.getElementById(id ?? 'top');
    
    if (ele) {
        setTimeout(() => {
            ele?.scrollIntoView({ behavior: 'smooth' });
        }, 0);
    }
};
